import {AxiosResponse} from 'axios';
import {AsyncResult} from 'Core/models/Async';
import axios from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, RequestMethod} from 'Shared/utilities/fetchHelpers';

const getAxiosConfigAndHeaders = () => {
  const axiosConfig = getAxiosConfig();

  return {
    ...axiosConfig,
    headers: {
      ...axiosConfig.headers,
    },
  };
};

export const A360_COMMMISSIONS_REPORT_ROOT_URI = 'api/commissions/v1/commissionsReport';

export const A360_COMMMISSIONS_ROOT_URI = 'api/commissions/v1/commissionStatements';

export const fetchA360CommissionsData = (baseURL: string) => {
  async function fetchDataFromAPI<T>(endpoint: string, method: RequestMethod.GET): Promise<AsyncResult<T>>;
  async function fetchDataFromAPI<T, P>(
    endpoint: string,
    method: RequestMethod.POST,
    payload: P
  ): Promise<AsyncResult<T>>;

  async function fetchDataFromAPI<T, P>(endpoint: string, method: RequestMethod, payload?: P) {
    const apiUrl = `${baseURL}/${endpoint}`;

    let response: AxiosResponse<T, any>;

    if (method === RequestMethod.POST) {
      response = await axios.post<T>(apiUrl, payload, getAxiosConfigAndHeaders());
    } else {
      response = await axios.get<T>(apiUrl, getAxiosConfigAndHeaders());
    }
    return handleResponse(response);
  }
  return fetchDataFromAPI;
};